import PMBModalRemove from 'components/PMBModalRemove'
import PMBPagination from 'components/PMBPagination'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import PMBTooltip from 'components/PMBTooltip'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useDebounce } from 'helpers'
import useIsMobile from 'hooks/useIsMobile'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { ChevronDown, Edit2, Plus, Share, Trash2 } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import { useDeleteMapSchemaMutation } from '../map-schema/mapSchemaApiSlice'
import ModalAddEditMapSchema from '../map-schema/ModalAddEditMapSchema'
import { setFetchOption } from './masterItemsSlice'
import { useFetchSchemasQuery } from './schemaListApiSlice'
import SvgIcon from 'components/Icon/SvgIcon'
import ModalShareMasterItem from './ModalShareMasterItem'
import { ResponsiveActionButton } from 'components/Buttons'

const SchemaList = ({ isActive }) => {
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const { enqueueSnackbar } = useSnackbar()

  const { tag } = useSelector((state) => state.masterItems)

  const [searchInput, setSearchInput] = useState('')
  const [isFilter, setIsFilter] = useState(false)

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isOpenModalAddEdit, setIsOpenModalAddEdit] = useState(false)
  const [isOpenModalShare, setIsOpenModalShare] = useState(false)
  const [dataSchemaById, setDataSchemaById] = useState(null)

  const { data, isFetching, refetch } = useFetchSchemasQuery(
    {
      page: tag?.page ?? 0,
      size: tag?.size ?? 10,
      s: tag?.s,
      sortby: tag?.sortby,
      sortdir: tag?.sortdir,
    },
    { refetchOnMountOrArgChange: true, skip: !isActive },
  )

  const [deleteMapSchema, { isLoading: isDeleting }] =
    useDeleteMapSchemaMutation()

  // HANDLE SUBMIT REMOVE BY ID
  const handleSubmitRemoveById = async () => {
    try {
      if (!dataSchemaById?.id) {
        enqueueSnackbar('Data skema tidak valid untuk dihapus', {
          variant: 'error',
        })
        return
      }

      const response = await deleteMapSchema(dataSchemaById.id)

      if (response && response?.data) {
        enqueueSnackbar(
          `Skema "${dataSchemaById?.createMethodLabel}" berhasil dihapus`,
          {
            variant: 'success',
          },
        )
        setIsOpenDeleteModal(false)
        setDataSchemaById(null)
        refetch()
      }
    } catch (error) {
      enqueueSnackbar('Skema gagal dihapus', {
        variant: 'error',
      })
    }
  }

  const columns = [
    // {
    //   name: <span>ID</span>,
    //   selector: 'id',
    //   sortable: true,
    //   sortField: 'id',
    //   grow: 0.5,
    //   cell: (row) => {
    //     return <span className="m-0">{row?.id}</span>
    //   },
    //   minWidth: '80px',
    // },
    // {
    //   name: <span>Nama Skema</span>,
    //   selector: 'label',
    //   sortable: true,
    //   sortField: 'label',
    //   grow: 2,
    //   cell: (row) => {
    //     return <span className="m-0">{row?.label}</span>
    //   },
    //   minWidth: '200px',
    // },
    {
      name: <span>Nama Skema</span>,
      selector: 'createMethodLabel',
      sortable: true,
      sortField: 'createMethodLabel',
      grow: 2,
      cell: (row) => {
        return <span className="m-0">{row?.createMethodLabel}</span>
      },
      minWidth: '200px',
    },
    {
      name: <span>Jumlah Bahan Baku</span>,
      selector: 'numInput',
      sortable: true,
      sortField: 'numInput',
      grow: 1,
      cell: (row) => {
        return <span className="m-0 text-center d-block">{row?.numInput}</span>
      },
      minWidth: '120px',
      center: true,
    },
    {
      name: <span>Jumlah Barang Jadi</span>,
      selector: 'numOutput',
      sortable: true,
      sortField: 'numOutput',
      grow: 1,
      cell: (row) => {
        return <span className="m-0 text-center d-block">{row?.numOutput}</span>
      },
      minWidth: '120px',
      center: true,
    },
    {
      name: <span className="fw-semibold"></span>,
      width: '120px',
      right: true,
      cell: (row, index) => (
        <div
          className="d-flex align-items-center justify-content-end"
          style={{ gap: '12px' }}
          data-testid={`master-item-table-row-${row?.id}`}
        >
          <div
            id={`share-schema-${index}`}
            data-testid={`master-item-row-share-${row?.id}`}
          >
            <ResponsiveActionButton
              size={16}
              name="share-2"
              iconName="share-2"
              label="Bagikan"
              id={`share-schema-${index}`}
              onClick={(e) => {
                e.stopPropagation()
                setDataSchemaById(row)
                setIsOpenModalShare(true)
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div
            id={`edit-schema-${index}`}
            data-testid={`master-item-row-edit-${row?.id}`}
          >
            <Edit2
              size={16}
              onClick={(e) => {
                e.stopPropagation()
                setDataSchemaById(row)
                setIsOpenModalAddEdit(true)
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <PMBTooltip target={`edit-schema-${index}`} text="Edit" />

          <div
            id={`remove-schema-${index}`}
            data-testid={`master-item-row-delete-${row?.id}`}
          >
            <Trash2
              size={16}
              onClick={(e) => {
                e.stopPropagation()
                setIsOpenDeleteModal(true)
                setDataSchemaById(row)
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <PMBTooltip target={`remove-schema-${index}`} text="Hapus" />
        </div>
      ),
    },
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction?.toUpperCase(),
      }),
    )
  }

  useEffect(() => {
    dispatch(setFetchOption({ page: 0 }))
  }, [searchInput])

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        s: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    if (!value?.trim()) {
      setIsFilter(false)
    } else {
      setIsFilter(true)
    }
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s?.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <>
      {/* MODAL ADD/EDIT MAP SCHEMA */}
      <ModalAddEditMapSchema
        isOpen={isOpenModalAddEdit}
        toggle={() => {
          setIsOpenModalAddEdit((prev) => !prev)
          setDataSchemaById(null)
        }}
        onSuccess={refetch}
        dataSchemaById={dataSchemaById}
        // prefilledItemId={itemId}
        // itemName={itemName}
      />
      {/* MODAL SHARE */}
      <ModalShareMasterItem
        isOpen={isOpenModalShare}
        toggle={() => {
          setIsOpenModalShare((prev) => !prev)
          setDataSchemaById(null)
        }}
        onSuccess={refetch}
        dataSchemaById={dataSchemaById}
      />

      {/* MODAL REMOVE MAP SCHEMA */}
      <PMBModalRemove
        isOpen={isOpenDeleteModal}
        onClose={() => {
          setIsOpenDeleteModal((prev) => !prev)
          setDataSchemaById(null)
        }}
        title={`Hapus Skema Produksi`}
        dataId={dataSchemaById?.id}
        desc={`Apakah Anda yakin ingin menghapus skema "${dataSchemaById?.createMethodLabel}"?`}
        isLoading={isDeleting}
        onRemoveData={handleSubmitRemoveById}
        buttonTitle="Hapus"
      />

      <DataTable
        responsive
        persistTableHead
        defaultSortFieldId={1}
        defaultSortAsc={true}
        columns={columns}
        data={data?.items || []}
        progressPending={isFetching}
        paginationTotalRows={data?.totalItems}
        pagination
        paginationServer
        highlightOnHover
        pointerOnHover
        customStyles={{
          rows: {
            style: {
              '&:hover': {
                backgroundColor: '#f8f9fa',
                cursor: 'pointer',
              },
            },
          },
        }}
        paginationComponent={() => (
          <PMBPagination
            rowCount={data?.totalItems || 0}
            currentPage={tag?.page}
            rowsPerPage={tag?.size}
            setCurrentPage={(e) => {
              dispatch(setFetchOption({ page: e }))
            }}
            setRowsPerPage={(e) => {
              dispatch(setFetchOption({ size: e }))
            }}
          />
        )}
        progressComponent={
          <div style={{ margin: '100px 0px' }}>
            <Spinner color="primary" />
          </div>
        }
        onSort={handleSort}
        sortIcon={<ChevronDown />}
        sortServer
        subHeader={true}
        subHeaderComponent={
          <div className="w-100">
            <div
              className={`d-flex mb-1 ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}
            >
              <div className="mb-2">
                <div
                  className={
                    isMobile
                      ? 'd-flex flex-column gap-3'
                      : 'd-flex justify-content-between align-items-end'
                  }
                >
                  <div style={{ width: isMobile ? '100%' : 'auto' }}>
                    <label
                      className="form-label mb-2"
                      style={{ fontSize: '0.875rem', fontWeight: 500 }}
                    >
                      Cari Skema
                    </label>
                    <PMBSearchInputGroup
                      value={searchInput}
                      placeholder="Cari nama skema..."
                      onChange={(e) => onHandleSearchChange(e.target.value)}
                      maxWidth={isMobile ? '100%' : '350px'}
                      onKeyDown={handleKeyDown}
                      testId="master-item-search-input"
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2">
                <Button
                  onClick={() => {
                    setDataSchemaById(null)
                    setIsOpenModalAddEdit(true)
                  }}
                  size="sm"
                  color="primary"
                  className={`d-flex align-items-center justify-content-center gap-2 ${isMobile ? 'w-100 py-2' : ''}`}
                  data-testid="master-item-add-button"
                >
                  <Plus size={16} />
                  Tambah Skema
                </Button>
              </div>
            </div>
          </div>
        }
        noDataComponent={
          <p className="my-3 fw-semibold">
            {isFilter
              ? 'Tidak ada data yang sesuai dengan pencarian Anda'
              : 'Belum ada skema yang tersedia'}
          </p>
        }
      />
    </>
  )
}

export default SchemaList
